import { render, staticRenderFns } from "./LeaderboardRow.vue?vue&type=template&id=bfdefb94&scoped=true"
import script from "./LeaderboardRow.vue?vue&type=script&lang=js"
export * from "./LeaderboardRow.vue?vue&type=script&lang=js"
import style0 from "./LeaderboardRow.vue?vue&type=style&index=0&id=bfdefb94&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfdefb94",
  null
  
)

export default component.exports